import { BrowserRouter } from "react-router-dom";
import Routing from "./Routing";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import React, { useEffect } from "react";

function App() {
  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      const activeEl = document.activeElement;
      const isFormInput =
        activeEl &&
        (activeEl.tagName === "INPUT" ||
          activeEl.tagName === "TEXTAREA" ||
          activeEl.tagName === "SELECT" ||
          activeEl.isContentEditable);

      const isMac =
        navigator.platform.toUpperCase().includes("MAC") ||
        navigator.userAgent.includes("Mac");

      // 1. Prevent Cmd/Alt + Arrow Left/Right from navigating browser back/forward
      const isNavArrow = isMac
        ? e.metaKey && (e.key === "ArrowLeft" || e.key === "ArrowRight")
        : e.altKey && (e.key === "ArrowLeft" || e.key === "ArrowRight");

      if (isNavArrow) {
        if (!isFormInput) {
          // Block browser back/forward when focus is outside inputs
          e.preventDefault();
        }
        // Inside inputs on Mac, native Cmd+Arrow jumps cursor to start/end of line.
      }

      // 2. Prevent Mac standard browser history navigation: Cmd + [ and Cmd + ]
      if (e.metaKey && (e.key === "[" || e.key === "]")) {
        e.preventDefault();
      }

      // 3. Prevent Arrow keys on stepper / tab buttons from switching focus or tabs
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        const isTab =
          activeEl?.getAttribute("role") === "tab" ||
          activeEl?.closest('[role="tablist"]') ||
          activeEl?.closest(".bs-stepper-header");

        if (isTab) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    };

    // Attach in capture phase (true) to intercept before child handlers
    window.addEventListener("keydown", handleGlobalKeyDown, true);
    return () => window.removeEventListener("keydown", handleGlobalKeyDown, true);
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter>
        <ToastContainer />
        <Routing />
      </BrowserRouter>
    </Provider>
  );
}

export default App;